import React from 'react'
import PropTypes from 'prop-types'
import { Env } from '@morningtrain/helpers'
import { CallbackOnPipe, Pipeline, TriggerPipelineOnClick } from '@morningtrain/react-helpers'
import useRouter from '../hooks/use-router'
import { Can } from '@morningtrain/react-auth'
import LabelForRoute from './LabelForRoute'
import NavigateOnPipe from '../pipes/NavigateOnPipe'
import { useParameters } from '@morningtrain/react-resources'

function Link (props) {
  const router = useRouter()

  const { route } = props

  const parameters = useParameters(props.parameters)
  let href = props.href

  if (route && !href) {
    href = router.route(route, parameters)
  }

  const linkClassName = [
    props.className,
    (href === location.href || route === Env.get('page.route')) ? 'active' : 'inactive'
  ].filter(c => c).join(' ')

  const anchorProps = {
    href: href,
    className: linkClassName
  }

  if (props.newTab) {
    anchorProps.target = '_blank'
  }

  const handleOnClick = (payload) => {
    if (typeof props.onClick === 'function') {
      props.onClick(payload)
    }

    return payload
  }

  const innerLink = (
    <Pipeline>
      <TriggerPipelineOnClick>
        <a {...anchorProps}>
          <LabelForRoute route={props.route} label={props.label}>
            {props.children}
          </LabelForRoute>
          {props.pipeline}
          <CallbackOnPipe callback={handleOnClick} />
          <NavigateOnPipe
            href={props.href}
            route={props.route}
            routeParameters={props.parameters}
            newTab={props.newTab}
            disableRouting={props.disableRouting}
          />
        </a>
      </TriggerPipelineOnClick>
    </Pipeline>
  )

  if (!route) {
    return innerLink
  }

  return (
    <Can permission={route}>
      {innerLink}
    </Can>
  )
}

Link.defaultProps = {
  label: null,
  href: null,
  className: null,
  pipeline: null,
  newTab: false,
  disableRouting: false,
  parameters: {}
}

Link.propTypes = {
  label: PropTypes.node,
  href: PropTypes.string,
  route: PropTypes.string,
  pipeline: PropTypes.node,
  newTab: PropTypes.bool,
  disableRouting: PropTypes.bool,
  parameters: PropTypes.object,
  className: PropTypes.string
}

export default Link
